import CategoryTwoToneIcon from '@mui/icons-material/CategoryTwoTone';

const HighLightCategoryRoutes = {
  id: 'HighLightCategory-group',
  title: 'HighLightCategory Management',
  type: 'group',
  children: [
    {
      id: 'HighLightCategory-list',
      title: 'HighLightCategory List',
      type: 'item',
      url: '/highlightcategory/list',
      icon: CategoryTwoToneIcon,
      target: false
    }
  ]
};

export default HighLightCategoryRoutes;
